// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__RIuLb","right":"Footer_right__zDnWx","buttons":"Footer_buttons__25ek3"};